import { render, staticRenderFns } from "./MapModel.vue?vue&type=template&id=c2241488&scoped=true"
import script from "./MapModel.vue?vue&type=script&lang=js"
export * from "./MapModel.vue?vue&type=script&lang=js"
import style0 from "./MapModel.vue?vue&type=style&index=0&id=c2241488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2241488",
  null
  
)

export default component.exports